import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../components/Sidebar";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FaRegComments } from "react-icons/fa";
import { FiSearch } from "react-icons/fi"
import { FiCopy } from "react-icons/fi"
import { toast, ToastContainer } from "react-toastify";
import { PiNeedleBold } from "react-icons/pi";

const NlNcStudentManager = () => {
  const fileInputRef = useRef(null);
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [collegeData, setCollegeData] = useState([]);
  const [assignedEmployee, setAssignedEmployee] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [searchName, setSearchName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startSearchFollowUpDate, setstartSearchFollowUpDate] = useState("");
  const [endSearchFollowUpDate, setEndSearchFollowUpDate] = useState("");
  const [searchOption, setSearchOption] = useState("");
  const [college, setCollege] = useState("");
  const [role, setRole] = useState("");
  const roleType = [
    {label: "All", value: "all"},
    {label: "L2", value: "L2"},
    {label: "L3", value: "L3"},
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [student, setStudent] = useState("");
  const [userRole, setUserRole] = useState(localStorage.getItem("userData"));
  const [dateError, setDateError] = useState("");
  const [timeError, setTimeError] = useState("");

  const itemsPerPage = 20;
  const navigate = useNavigate()
  const [message, setMessage] = useState("");
  const handleButtonClick = () => {
    fileInputRef.current.click(); // Opens file picker
  };
  const downloadCSV = async () => {
    try {
      let filter = {
        name: searchName,
        startSearchFollowUpDate,
        endSearchFollowUpDate,
        searchOption,
        startDate,
        endDate,
        college
      };

      // Convert filter object to query string
      const queryString = new URLSearchParams(filter).toString();

      // Fetch Excel file as a blob
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/download-excel?${queryString}`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
        responseType: "blob", // Important for downloading files
      });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a temporary link and trigger download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "students.xlsx"); // File name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const fetchData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-all-students`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    setStudents(response?.data?.users);
    
    // Filter only Nl and lookingForNY students
    const nlNcStudents = response?.data?.users?.filter(student => 
     student.status === "Nl" || student.status === "lookingForNY"
    );
    
    if (filteredStudents?.length > 0) {
      let allData = []
      for (let item of filteredStudents) {
        nlNcStudents?.forEach(v => {
          if (v?._id === item?._id) {
            allData.push(v)
            return
          }
        })
      }
      paginate(currentPage)
      setFilteredStudents(allData);
      return
    }
    setFilteredStudents(nlNcStudents);
  };

  const getComments = async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-comments/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    setComments(response?.data?.commentList)
  };

  const fetchEmployeData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/sub-admin`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    setEmployees(response?.data?.users?.map((value) => { return { value: value?._id, label: value?.name } }));
  };

  const fetchCollegeData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/all-colleges`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    setCollegeData(response?.data?.data?.map((value) => { return { value: value?._id, label: value?.name } }));
  };

  useEffect(() => {
    fetchData();
    fetchCollegeData()
    if (userRole?.role === "admin") {
      fetchEmployeData();
    }
  }, [userRole]);

  useEffect(() => {
    if (localStorage.getItem("userData")) {
      setUserRole(JSON.parse(localStorage.getItem("userData")))
    }
  }, [])

  // Status options for Nl and lookingForNY only
  const statusOptions = [
    { value: "pending", label: "Pending" },
    {value: "NeedsTime", label: "Needs time/ long follow up"},
    { value: "interested", label: "Interested" },
    { value: "connected", label: "Connected" },
    { value: "Nl", label: "Nl" },
    { value: "lookingForNY", label: "Looking for NY" },
    { value: "TakenAdmWithIn20Days", label: "Clg pitched need L3 follow up" },
    { value: "TakenAdmWithIn30Days", label: "Clg pitched std needs time" },
    { value: "willTakeAdmAfterExam", label: "Will take adm after examination" },
    { value: "NC", label: "NC" },
    { value: "CAF", label: "CAF" },
    { value: "walkIn", label: "Walk in" },
    { value: "walkInCompleted", label: "Walk in Completed" },
    { value: "seatBooked", label: "Seat Booked" },
    { value: "admissionSuccessful", label: "Admission Successful" },
    { value: "waitForWbjee", label: "Wait for WBJEE" },
    { value: "waitForJenpas", label: "Wait for JENPAS" },
  ];

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const confirmDeletion = async () => {
    await axios.delete(`${process.env.REACT_APP_BASE_URL}/delete-student/${deleteId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    }).then((res) => {
      fetchData()
      closeModal();
    }).catch(err => {
      console.log(err)
    })
    closeModal();
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStudents([]);
    } else {
      setSelectedStudents(filteredStudents.map((student) => student._id));
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (id) => {
    if (selectedStudents.includes(id)) {
      setSelectedStudents(selectedStudents.filter((studentId) => studentId !== id));
    } else {
      setSelectedStudents([...selectedStudents, id]);
    }
  };

  const handleAssign = async () => {
    if (selectedStudents.length === 0) {
      alert("Please select at least one student.");
      return;
    }
    if (!assignedEmployee) {
      alert("Please select an employee.");
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/assign-employee`, {
        studentIds: selectedStudents,
        employeeId: assignedEmployee.value,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });

      alert("Students assigned successfully!");
      setSelectedStudents([]);
      setSelectAll(false);
      setAssignedEmployee(null);
      fetchData();
    } catch (error) {
      console.error("Error assigning students:", error);
      alert("Failed to assign students.");
    }
  };

  const handleSearch = () => {
    const results = students.filter(
      (student) =>
        (student.name.toLowerCase().includes(searchName.toLowerCase()) || student.mobile.toLowerCase().includes(searchName.toLowerCase())) &&
        (!startDate || new Date(student.createdAt) >= new Date(startDate)) &&
        (!endDate || new Date(student.createdAt) <= new Date(endDate)) &&
        // Only include NL, NC, and lookingForNY students
        (student.status === "Nl" || student.status === "lookingForNY")
    );
    setCurrentPage(1)
    setFilteredStudents(results);
  };

  const handleReset = () => {
    setSearchName("");
    setStartDate("");
    setEndDate("");
    setstartSearchFollowUpDate("");
    setEndSearchFollowUpDate("");
    setSearchOption("");
    setCollege("")
    // Reset to only Nl and lookingForNY students
    const nlNcStudents = students.filter(student => 
      student.status === "Nl" || student.status === "lookingForNY"
    );
    setFilteredStudents(nlNcStudents);
  };

  const handleCopyStudentData = (student) => {
    // Create a simplified copy of student data with readable information
    const simplifiedStudent = `Name: ${student.name || ""}
Email: ${student.email || ""}
Mobile: ${student.mobile || ""}
Address: ${student.address || ""}
Courses: ${student.courseDetail?.map(course => course.name).join(", ")}
Colleges: ${student?.collegeDetail?.map(college => college.name).join(", ")}`;

    navigator.clipboard.writeText(simplifiedStudent).then(() => {
      toast("Student data copied to clipboard!");
    }).catch(err => {
      console.error('Failed to copy student data: ', err);
      toast("Failed to copy student data");
    });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentStudents = filteredStudents.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredStudents.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [isEditing, setIsEditing] = useState('');
  const [isTimeEditing, setIsTimeEditing] = useState('');
  const [isL3Editing, setIsL3Editing] = useState('');
  const [isL3TimeEditing, setIsL3TimeEditing] = useState('');
  const [isStatusEditing, setIsStatusEditing] = useState('');
  const [isApiFailedEditing, setIsApiFailedEditing] = useState('');
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [dateL3, setDateL3] = useState("");
  const [timeL3, setTimeL3] = useState("");
  const [status, setStatus] = useState("");
  const [newDate, setNewDate] = useState("");
  const [newTime, setNewTime] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [apiFailed, setApiFailed] = useState(false);
  const [newCollege, setNewCollege] = useState("");
  const [comments, setComments] = useState([])

  const handleNewDateChange = (e) => {
    setNewDate(e.target.value);
  };

  const handleNewTimeChange = (e) => {
    setNewTime(e.target.value);
  };

  const handleNewStatusChange = (e) => {
    setNewStatus(e.target.value);
  };

  const handleNewCollegeChange = (selectedOption) => {
    setNewCollege(selectedOption);
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleApiFailedChange = (e) => {
    setApiFailed(e.target.value === 'true');
  };

  const handleBlur = async (studentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/update-student/${studentId}`, {
        followUp: date,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      fetchData();
    } catch (error) {
      console.error("Error updating follow-up date:", error);
    }
    setIsEditing('');
  };

  const handleTimeBlur = async (studentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/update-student/${studentId}`, {
        followUpTime: time,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      fetchData();
    } catch (error) {
      console.error("Error updating follow-up time:", error);
    }
    setIsTimeEditing('');
  };

  const handleL3Blur = async (studentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/update-student/${studentId}`, {
        followUpL3: dateL3,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      fetchData();
    } catch (error) {
      console.error("Error updating L3 follow-up date:", error);
    }
    setIsL3Editing('');
  };

  const handleL3TimeBlur = async (studentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/update-student/${studentId}`, {
        followUpTimeL3: timeL3,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      fetchData();
    } catch (error) {
      console.error("Error updating L3 follow-up time:", error);
    }
    setIsL3TimeEditing('');
  };

  const handleStatusBlur = async (studentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/update-student/${studentId}`, {
        status: status,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      fetchData();
    } catch (error) {
      console.error("Error updating status:", error);
    }
    setIsStatusEditing('');
  };

  const handleApiFailedBlur = async (studentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/update-student/${studentId}`, {
        apiFailed: apiFailed,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      fetchData();
    } catch (error) {
      console.error("Error updating API failed status:", error);
    }
    setIsApiFailedEditing('');
  };

  // Add missing functions from StudentManager
  const fetchProfileData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-profile`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    console.log(response?.data?.users?.roleType)
    setRole(response?.data?.users?.roleType ? response?.data?.users?.roleType : "all");
  };

  const handleRoleType = (e) => {
    setRole(e.target.value)
  }

  const handleRoleBlur = () => {
    console.log(role)
  }

  const handleSearchChange = (e) => {
    setSearchOption(e.target.value);
  };

  const handleSearchCollege = (e) => {
    setCollege(e.target.value);
  };

  const handleSearchNewCollege = (e) => {
    setNewCollege(e.target.value);
  };

  const handleFollowUpSearch = () => {
    const results = students.filter((student) =>
      (!searchOption || student?.status === searchOption) &&
      (!selectedEmployee?.value || (Array.isArray(student?.employees) && student?.employees?.length > 0 && student?.employees.some((v) => v === selectedEmployee?.value))) &&
      (!startSearchFollowUpDate || new Date(role === "L3" ? student.followUpL3 : student.followUp) >= new Date(startSearchFollowUpDate)) &&
      (!endSearchFollowUpDate || new Date(role === "L3" ? student.followUpL3 : student.followUp) <= new Date(endSearchFollowUpDate)) &&
      // Only include Nl and lookingForNY students
      (student.status === "Nl" || student.status === "lookingForNY")
    );
    setCurrentPage(1)
    setFilteredStudents(results);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setMessage("Uploading...");

    const formData = new FormData();
    formData.append("file", file);

    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/bulk-upload-students`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });

      setMessage("File uploaded successfully!");
      fetchData(); // Refresh the student list
    } catch (error) {
      console.error("Error uploading file:", error);
      setMessage("Error uploading file");
    }
  };

  const [newComment, setNewComment] = useState("");
  const [commentError, setCommentError] = useState("");

   const handlePostComment = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) {
      setCommentError("Please enetr minimum one character")
      return
    }
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/add-comment`, { studentId: deleteId, message: newComment, date: newDate, time: newTime, college: newCollege, status: newStatus }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      setNewComment("")
      setNewCollege("")
      setNewDate("")
      setNewTime("")
      setNewStatus("")
      setIsCommentModalOpen(false)
      fetchData()
    } catch (error) {
      console.error("Error adding student:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "status") {
      setStatus(value);
    }
  };

  const handleDateL3Change = (e) => {
    setDateL3(e.target.value);
  };

  const handleTimeL3Change = (e) => {
    setTimeL3(e.target.value);
  };

  useEffect(()=>{
    fetchProfileData()
  },[])


  return (
    <div className="min-h-screen flex bg-gray-100">
      <ToastContainer />
      <Sidebar />

      <div className="flex-1 p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-black">Nl & LookingForNY Student Manager</h1>
          <select
              name="college"
              value={role}
              onChange={handleRoleType}
              onBlur={handleRoleBlur}
              className="border border-gray-300 rounded-md px-4 py-2 w-1/4"
            >
              <option value="" disabled>Select Your Role</option>
              {roleType.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          {
            (userRole?.role === "admin" || userRole?.managers?.["Student Manager"]?.add) && <div className="flex gap-4">
              <NavLink
                to="/add-student"
                className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
              >
                + Add Student
              </NavLink>
              <input
                type="file"
                accept=".xlsx, .csv"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <button
                className="bg-orange text-white px-6 py-2 rounded-md shadow-md"
                onClick={handleButtonClick}
              >
                Upload CSV
              </button>
              <button
                className="bg-orange text-white px-6 py-2 rounded-md shadow-md"
                onClick={downloadCSV}
              >
                Download CSV
              </button>
            </div>
          }
        </div>

        {/* Search Section */}
        <div className="bg-white shadow-md  rounded-lg p-4 mb-6 flex items-center gap-4">
          <div className="relative w-1/4">
            <input
              type="text"
              placeholder="Search by Name or Number"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              className="border border-gray-300 rounded-md pl-4 pr-10 py-2 w-full"
            />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" onClick={handleSearch}>
              <FiSearch />
            </span>
          </div>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border border-gray-300 rounded-md px-4 py-2 w-1/4"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border border-gray-300 rounded-md px-4 py-2 w-1/4"
          />
          <button
            onClick={handleSearch}
            className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
          >
            Search
          </button>
          <button
            onClick={handleReset}
            className="bg-orange text-white px-6 py-2 rounded-md shadow-md"
          >
            Reset
          </button>
        </div>

        {/* Assign Section */}
        <div className="bg-white shadow-md rounded-lg p-4 mb-6 flex items-center gap-4">
          {userRole?.role === "admin" && <>
            <Select
              isMulti
              options={employees}
              value={assignedEmployee && assignedEmployee}
              onChange={(selected) => setAssignedEmployee(selected)}
              className="border border-gray-300 rounded-md"
              placeholder="Assign employees"
            />
            <button
              onClick={handleAssign}
              className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
            >
              Assign to Employee
            </button>
          </>
          }
          {(userRole?.role === "admin" || userRole?.managers?.["Student Manager"]?.add) && <>Follow up:
            <input
              type="date"
              value={startSearchFollowUpDate}
              onChange={(e) => setstartSearchFollowUpDate(e.target.value)}
              className="border border-gray-300 rounded-md px-4 py-2 w-1/8"
            />
            <input
              type="date"
              value={endSearchFollowUpDate}
              onChange={(e) => setEndSearchFollowUpDate(e.target.value)}
              className="border border-gray-300 rounded-md px-4 py-2 w-1/8"
            />
            <select
              name="status"
              value={searchOption}
              onChange={handleSearchChange}
              className="border border-gray-300 rounded-md px-4 py-2 w-1/12"
            >
              <option value="" disabled>Select status</option>
              {statusOptions.map((option) => (
                (option.value === "lookingForNY" || option.value === "Nl") && (
                  <option key={option.value} value={option.value}>{option.label}</option>
                )
              ))}
            </select>
            <select
              name="college"
              value={college}
              onChange={handleSearchCollege}
              className="border border-gray-300 rounded-md px-4 py-2 w-1/12"
            >
              <option value="" disabled>Select college</option>
              {collegeData.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {userRole?.role === "admin" && <>
              <Select
                // isMulti
                options={employees}
                value={selectedEmployee}
                onChange={(selected) => setSelectedEmployee(selected)}
                className="border border-gray-300 rounded-md"
                placeholder="Select employees"
              />
            </>
            }
            <button
              onClick={handleFollowUpSearch}
              className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
            >
              Search
            </button>
            <button
              onClick={handleReset}
              className="bg-orange text-white px-6 py-2 rounded-md shadow-md"
            >
              Reset
            </button></>}
        </div>

        {/* Table */}
        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
          <table className="table-auto w-full">
            <thead className="bg-blue text-white">
              <tr>
                <th className="px-4 py-4">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="px-4 py-4">Student Name</th>
                <th className="px-4 py-4">Mobile</th>
                <th className="px-4 py-4">Email</th>
                <th className="px-4 py-4">Course</th>
                <th className="px-4 py-4">College</th>
                {(role==="L2" || role === "all") && <> <th className="px-4 py-4">Follow up L2</th>
                <th className="px-4 py-4">Time L2</th></>}
                {(role==="L3" || role === "all") && <> <th className="px-4 py-4">Follow up L3</th>
                <th className="px-4 py-4">Time L3</th></>}
                <th className="px-4 py-4">Status</th>
                <th className="px-4 py-4">Assigned</th>
                <th className="px-4 py-4">Api Failed</th>
                <th className="px-4 py-4">Copy Data</th>
                <th className="px-4 py-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentStudents.map((student) => (
                <tr key={student.id} className={`border-b`}>
                  <td className="px-4 py-2">
                    <input
                      type="checkbox"
                      checked={selectedStudents.includes(student._id)}
                      onChange={() => handleCheckboxChange(student._id)}
                    />
                  </td>
                  <td className="px-4 py-2 flex">
                    <p style={{ paddingRight: "10px" }}>
                      {student?.adminCommented && <PiNeedleBold />}
                      {student.name} 
                      {student?.adminCommented && (
                        <span className="ml-2 text-sm text-blue-600 italic">
                          "{student?.adminCommented}"
                        </span>
                      )}
                    </p>
                    <button
                    onClick={() => {
                      setStudentName(student.name)
                      setStudent(student)
                      getComments(student?._id)
                      setDeleteId(student?._id)
                      setIsCommentModalOpen(true)
                    }
                    }
                    className="bg-red-500 text-white px-3 py-1 rounded-md"
                  >
                    <div class="tooltip"> <FaRegComments />
                      <span class="tooltiptext">{student?.lastComment?.length > 0 ? student?.lastComment[0]?.message : "Comments"}</span>
                    </div>
                  </button></td>

                  <td className="px-4 py-2">{student.mobile}</td>
                  <td className="px-4 py-2">{student?.email}</td>
                  <td className="px-4 py-2">{
                    student?.courseDetail?.length > 0 ? student?.courseDetail?.map((e, i) => e?.name + (i === student?.courseDetail?.length - 1 ? "" : ", ")) : "Unassigned"
                  }</td>
                  <td className="px-4 py-2">{
                    student?.collegeDetail?.length > 0 ? student?.collegeDetail?.map((e, i) => e?.name + (i === student?.collegeDetail?.length - 1 ? "" : ", ")) : "Unassigned"
                  }</td>
                  {(role==="L2" || role === "all") &&<> <td className="px-4 py-2">
                    {isEditing === student?._id ? (
                      <input
                        type="date"
                        value={date}
                        onChange={handleDateChange}
                        onBlur={() => handleBlur(student?._id)} // Save the date on blur
                        autoFocus
                        className="border rounded px-2 py-1"
                      />
                    ) : (
                      <span onClick={() => {
                        setIsEditing(student?._id)
                        setDate(student?.followUp)
                      }} className="cursor-pointer">
                        {(student?.followUp && new Date(student.followUp).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' })) || "Click to select a date"}
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    {isTimeEditing === student?._id ? (
                      <input
                        type="time"
                        value={time}
                        onChange={handleTimeChange}
                        onBlur={() => handleTimeBlur(student?._id)} // Save the date on blur
                        autoFocus
                        className="border rounded px-2 py-1"
                      />
                    ) : (
                      <span onClick={() => {
                        setIsTimeEditing(student?._id)
                        setTime(student?.followUpTime)
                      }} className="cursor-pointer">
                        {(student?.followUpTime) || "Click to select a time"}
                      </span>
                    )}
                  </td></>}
                  {(role==="L3" || role === "all") &&<> <td className="px-4 py-2">
                    {isL3Editing === student?._id ? (
                      <input
                        type="date"
                        value={dateL3}
                        onChange={handleDateL3Change}
                        onBlur={() => handleL3Blur(student?._id)} // Save the date on blur
                        autoFocus
                        className="border rounded px-2 py-1"
                      />
                    ) : (
                      <span onClick={() => {
                        setIsL3Editing(student?._id)
                        setDateL3(student?.followUpL3)
                      }} className="cursor-pointer">
                        {(student?.followUpL3 && new Date(student?.followUpL3)?.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' })) || "Click to select a date"}
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    {isL3TimeEditing === student?._id ? (
                      <input
                        type="time"
                        value={timeL3}
                        onChange={handleTimeL3Change}
                        onBlur={() => handleL3TimeBlur(student?._id)} // Save the date on blur
                        autoFocus
                        className="border rounded px-2 py-1"
                      />
                    ) : (
                      <span onClick={() => {
                        setIsL3TimeEditing(student?._id)
                        setTimeL3(student?.followUpTimeL3)
                      }} className="cursor-pointer">
                        {(student?.followUpTimeL3) || "Click to select a time"}
                      </span>
                    )}
                  </td></>}
                  <td className="px-4 py-2">
                    {isStatusEditing === student?._id ? (
                      <select
                        name="status"
                        value={status}
                        onChange={handleChange}
                        onBlur={() => handleStatusBlur(student?._id)}
                        className="border border-gray-300 rounded-md px-4 py-2"
                      >
                        <option value="" disabled>Select status</option>
                        {statusOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    ) : (
                      <span onClick={() => {
                        setIsStatusEditing(student?._id)
                        setStatus(student?.status)
                      }} className="cursor-pointer">
                        {(student?.status && statusOptions.map((option) => {
                          if (option?.value === student?.status) {
                            return option.label
                          }
                          return null
                        }).find(Boolean)) || "Click to change status"}
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    {
                      student?.employeeDetail?.length > 0 ? student?.employeeDetail?.map(e => e?.name + " ") : "Unassigned"
                    }</td>
                  <td className="px-4 py-2">
                    {isApiFailedEditing === student?._id ? (
                      <select
                        name="apiFailed"
                        value={apiFailed}
                        onChange={handleApiFailedChange}
                        onBlur={() => handleApiFailedBlur(student?._id)}
                        className="border border-gray-300 rounded-md px-4 py-2"
                      >
                        <option value="" disabled selected>Select Api Failed</option>
                        <option value={false}>No</option>
                        <option value={true}>Yes</option>

                      </select>
                    ) : (
                      <span onClick={() => {
                        setIsApiFailedEditing(student?._id)
                        setApiFailed(student?.apiFailed)
                      }} className="cursor-pointer">
                        {(student?.apiFailed && student?.apiFailed ? "Yes" : "No") || "Click to change status"}
                      </span>
                    )}
                  </td>
                   <td className="px-4 py-2">
                         <button
                           onClick={() => handleCopyStudentData(student)}
                           className="text-blue-500 hover:text-blue-700 transition-colors"
                           title="Copy student data"
                         >
                          <FiCopy />
                         </button>
                     </td>
                  <td className="px-4 py-2 flex gap-2">
                    {(userRole?.role === "admin" || userRole?.managers?.["Student Manager"]?.add) && <> <button
                      onClick={() => {
                        navigate("/edit-student", {
                          state: {
                            type: "edit",
                            data: student
                          }
                        })
                      }}
                      className="bg-orange text-white px-3 py-1 rounded-md"
                    >
                      <div class="tooltip">  <FaEdit />
                        <span class="tooltiptext">Edit</span>
                      </div>
                    </button>
                      <button
                        onClick={() => {
                          setDeleteId(student?._id)
                          openModal()
                        }
                        }
                        className="bg-red-500 text-white px-3 py-1 rounded-md"
                      >
                        <div class="tooltip"> <MdDelete />
                          <span class="tooltiptext">Delete</span>
                        </div>
                      </button>
                    </>}
                  </td>
                </tr>
              ))}
              {currentStudents.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-gray-500">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center items-center mt-6 space-x-1">
          {/* Previous Button */}
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 rounded-md ${currentPage === 1 ? 'bg-gray-200 text-gray-400' : 'bg-blue text-white'}`}
          >
            Prev
          </button>

          {/* Page Numbers */}
          {Array.from({ length: totalPages }, (_, index) => index + 1)
            .filter(page =>
              page === 1 ||
              page === totalPages ||
              (page >= currentPage - 1 && page <= currentPage + 1)
            )
            .map((page, i, arr) => {
              // Check if ellipsis should be inserted
              if (i > 0 && page !== arr[i - 1] + 1) {
                return (
                  <React.Fragment key={page}>
                    <span className="px-2 py-1 text-gray-500">...</span>
                    <button
                      onClick={() => paginate(page)}
                      className={`px-3 py-1 rounded-md ${currentPage === page ? 'bg-blue text-white' : 'bg-gray-200 text-gray-700'}`}
                    >
                      {page}
                    </button>
                  </React.Fragment>
                );
              }
              return (
                <button
                  key={page}
                  onClick={() => paginate(page)}
                  className={`px-3 py-1 rounded-md ${currentPage === page ? 'bg-blue text-white' : 'bg-gray-200 text-gray-700'}`}
                >
                  {page}
                </button>
              );
            })}

          {/* Next Button */}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-3 py-1 rounded-md ${currentPage === totalPages ? 'bg-gray-200 text-gray-400' : 'bg-blue text-white'}`}
          >
            Next
          </button>
        </div>

      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-semibold">Are you sure you want to delete?</h2>
            <div className="mt-4 flex justify-center space-x-4">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-md"
                onClick={confirmDeletion}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      {isCommentModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-4xl">
            <h2 className="text-xl font-semibold mb-4">Comments: {studentName} - {
                    student?.courseDetail?.length > 0 ? student?.courseDetail?.map((e, i) => e?.name + (i === student?.courseDetail?.length - 1 ? "" : ", ")) : "Unassigned"
                  } - {student?.mobile}</h2>

            {/* Scrollable comments area */}
            <div
              id="commentsContainer"
              className="h-72 overflow-y-auto border border-gray-300 rounded-md p-4 mb-4 space-y-3 bg-gray-50"
            >
              {comments.map((comment, index) => {
                const date = new Date(comment.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })
                const followUpDate = new Date(`${comment?.followUp?.split("T")[0]}T${comment?.followUpTime}`)
                const followUp = followUpDate.toLocaleDateString('en-GB')
                return (
                  <div key={index} className="bg-white text-gray-800 p-4 rounded-lg shadow-md space-y-2">
                    {/* Admin name */}
                    <div className="font-semibold text-blue-600">{comment?.adminData?.name}</div>

                    {/* Main message */}
                    <p className="text-lg">{comment?.message}</p>

                    {/* Optional details section */}
                    <div className="text-sm text-gray-700 space-y-1">
                      {comment?.collegeDetail?.length > 0 && (
                        <p><span className="font-medium">College:</span> {comment?.collegeDetail?.[0]?.name}</p>
                      )}
                      {!isNaN(followUpDate.getTime()) && (
                        <p><span className="font-medium">Follow-Up:</span> {followUp}</p>
                      )}
                      {comment?.status && (
                        <p><span className="font-medium">Status:</span> {(comment?.status && statusOptions.map((option) => {
                          if (option?.value === comment?.status) {
                            return option.label
                          }
                          return null
                        }).find(Boolean)) || " "}</p>
                      )}
                    </div>

                    {/* Timestamp */}
                    <p className="text-xs text-gray-500">{date}</p>
                  </div>

                )
              })}
            </div>

            {/* Textarea */}
            <textarea
              className="w-full h-32 border border-gray-300 rounded-md p-3 text-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2"
              placeholder="Write a comment..."
              value={newComment}
              onChange={(e) => {
                setNewComment(e.target.value)
                setCommentError("")
              }}
            />
            {commentError && <p className="text-red-600 text-sm mb-2">{commentError}</p>}

            {/* Input group */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-1">Date</label>
                <input
                  type="date"
                  value={newDate}
                  onChange={handleNewDateChange}
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                />
                {dateError && <p className="text-red-500 text-xs mt-1">{dateError}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Time</label>
                <input
                  type="time"
                  value={newTime}
                  onChange={handleNewTimeChange}
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                />
                {timeError && <p className="text-red-500 text-xs mt-1">{timeError}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">College</label>
                <select
                  name="college"
                  value={newCollege}
                  onChange={handleSearchNewCollege}
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                >
                  <option value="" disabled>Select college</option>
                  {collegeData.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Status</label>
                <select
                  name="status"
                  value={newStatus}
                  onChange={handleNewStatusChange}
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                >
                  <option value="" disabled>Select status</option>
                  {statusOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Buttons */}
            <div className="mt-4 flex justify-end space-x-3">
              <button
                className="bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-md"
                onClick={() => setIsCommentModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-blue hover:bg-blue-700 text-white px-5 py-2 rounded-md"
                onClick={(e) => {
                  if (!newDate) {
                    setDateError("Date is required")
                    return
                  } else {
                    setDateError("")
                  }

                  if (!newTime) {
                    setTimeError("Time is required")
                    return
                  } else {
                    setTimeError("")
                  }

                  handlePostComment(e)
                }}
              >
                Post
              </button>
            </div>
          </div>
        </div>

      )}

    </div>
  );
};

export default NlNcStudentManager;
